import { render, staticRenderFns } from "./AddTemplateBasic.vue?vue&type=template&id=7f1fb215&"
import script from "./AddTemplateBasic.vue?vue&type=script&lang=js&"
export * from "./AddTemplateBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddTemplateBasic.vue"
export default component.exports